import { EnrollmentPackageId, GroupId, PersonId } from '../../types/api/primaryKeys/PrimaryKey';
import { EmployeeDetail } from '../../types/api/employees/EmployeeDetail';
import { EmployeeDependent } from '../../types/api/employees/EmployeeDependent';
import ApiRequest from '../../utils/ApiRequest';

/**
 * Returns basic employee information for the specified person.
 * @param employeePersonId 
 */
export async function getEmployeeDetail(employeePersonId: PersonId) {
    const result = await ApiRequest.get<EmployeeDetail>(`people/${employeePersonId}`);
    return result;
}

export async function getEmployeePackagePersonData(packageId: EnrollmentPackageId, personId: PersonId) {
    const result = await ApiRequest.get<EmployeeDetail>(`packages/${packageId}/people/${personId}`);
    return result;
}

export async function updateEmployee(packageId: EnrollmentPackageId, personId: PersonId, data: Partial<EmployeeDetail>) {
    await ApiRequest.put(`packages/${packageId}/people/${personId}`, data);
}

export async function addEmployeeDependent(groupId: GroupId, employeePersonId: PersonId, dependent: EmployeeDependent) {
    await ApiRequest.post(`groups/${groupId}/employees/${employeePersonId}/dependents`, dependent);
}

export async function getEmployeeDependent(groupId: GroupId, employeePersonId: PersonId, dependentPersonId: PersonId) {
    const result = await ApiRequest.get<EmployeeDependent>(`groups/${groupId}/employees/${employeePersonId}/dependents/${dependentPersonId}`);
    return result;
}

export async function updateEmployeeDependent(groupId: GroupId, employeePersonId: PersonId, dependentPersonId: PersonId, dependent: EmployeeDependent) {
    await ApiRequest.put(`groups/${groupId}/employees/${employeePersonId}/dependents/${dependentPersonId}`, dependent);
}